import React, { useEffect, useRef, useState } from "react";
import { api_serverUrl } from "../../apiclients/apiurls";
import {
  MDBAlert,
  MDBBtn,
  MDBCol,
  MDBDatepicker,
  MDBIcon,
  MDBInput,
  MDBModalFooter,
  MDBRow,
  MDBScrollspy,
  MDBScrollspyLink,
  MDBSpinner,
  MDBTabsContent,
  MDBTabsPane,
} from "mdb-react-ui-kit";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import PopupLoader from "../popups/PopupLoader";
import {
  deleteMsTeamFields,
  deleteMsTenant,
  getMSTeamSettingsInfo,
  updateMSTeamsSettings,
} from "../../apiclients/streamsapi_bridge";
import SaveChanges from "../../components/topviews/saveCancel";
import TopSuccess from "../../components/header/TopSuccess";
import TopMessage from "../../components/header/TopMessage";

function MicroSoftTeam(setEdited, isActive) {
  const { t, i18n } = useTranslation();
  const [deleteBtn, setDeleteBtn] = useState(false);
  const [isloading, setIsloading] = useState(false);
  const section6 = useRef(null);
  const [internalError, setInternalError] = useState(false);
  const [delTenantPopUp, setDelTenantPopUp] = useState(false);
  const togglePopUp = () => setDelTenantPopUp(!delTenantPopUp);
  const [basicActive, setBasicActive] = useState("tab1");
  const [rerender, setrerender] = useState(true);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const containerRef = useRef(null);

  const handleBasicClick = (value) => {
    if (value === basicActive) {
      return;
    }
    setBasicActive(value);
  };

  useEffect(() => {
    if (successMessage) {
      setTimeout(() => {
        setSuccessMessage(""); // Clear the success message in the parent component
      }, 5000);
    }
  }, [successMessage]);

  const {
    register,
    handleSubmit,
    formState,
    setValue,
    setError,
    setFocus,
    reset,
    getValues,
    watch,
    control,
    clearErrors,
    formState: { dirtyFields, isDirty, errors },
  } = useForm({
    defaultValues: {
      msteams: {
        directory_tenant_id: "",
        app_client_id: "",
        client_secret_value: "",
        client_secret_exp_date: "",
      },
    },
  });

  async function getMSTeamInfo() {
    try {
      setIsloading(true);
      setInternalError(false);
      const response = await getMSTeamSettingsInfo(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid
      );
      const rawData = await response.json();
      console.log(
        "getAccPinAndCidDtls details :::::: " + JSON.stringify(rawData)
      );
      if (response.status === 200) {
        reset({
          msteams: {
            directory_tenant_id: rawData.msteams?.directory_tenant_id ?? "",
            app_client_id: rawData.msteams?.app_client_id ?? "",
            client_secret_value: rawData.msteams?.client_secret_value ?? "",
            client_secret_exp_date:
              rawData.msteams?.client_secret_exp_date ?? "",
          },
        });
        setDeleteBtn(rawData?.msteams?.delete_tenant_btn_visible ?? false);
        // console.log(`rawData?.acc_cid?.allow_shared_callerid  is ::: ${rawData?.msteams?.acc_cid}`);
      } else if (response.status === 500) {
        setInternalError(true);
      } else {
        console.log("bhewfwebfew fewufbewui");
        setInternalError(true);
      }
    } catch (e) {
      console.log(`Unable to process the request:${e}`);
      setInternalError(true);
    } finally {
      setIsloading(false);
    }
  }

  useEffect(() => {
    if (isActive || rerender) {
      getMSTeamInfo();
      setrerender(false);
    }
  }, [isActive, rerender]);

  async function handleDelMsTeamTennant() {
    try {
      // let update = {
      //   reqid: 64,
      //   siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      // };
      setIsloading(true);
      togglePopUp();
      let response = await deleteMsTeamFields(JSON.parse(sessionStorage.getItem("admin_session")).siteid);
      response = await response.json();
      setSuccessMessage(response.message);
      if (response.status === "success") {
        setValue("msteams.directory_tenant_id", "", { shouldDirty: false });
        setValue("msteams.app_client_id", "", {
          shouldDirty: false,
        });
        setValue("msteams.client_secret_value", "", { shouldDirty: false });
        setValue("msteams.client_secret_exp_date", "", { shouldDirty: false });
        setSuccessMessage(response.message);
        setDeleteBtn(false);
      } else if (response.status === "failed") {
        setErrorMessage(response.message);
        setInternalError(true);
      } else {
        setInternalError(true);
      }
    } catch (e) {
      console.log(`Unable to process the request:${e}`);
      setInternalError(true);
    } finally {
      setIsloading(false);
    }
  }

  function handleDelMsTeamTennantHelper() {
    setDelTenantPopUp(true);
  }

  const onSubmit = async (data) => {
    if (isDirty) {
      const modifiedData = prepareFinalJson(formState.dirtyFields, data);
      
      let update = {};
      console.log("fjen few iewoj " + JSON.stringify(modifiedData));
      if (Object.keys(modifiedData)?.length > 0) {
        update = {
          reqid: 170,
          siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
          msteams: {}
         
        };
        const msteamsKeys = [
          "directory_tenant_id",
          "app_client_id",
          "client_secret_value",
          "client_secret_exp_date",
        ];
        const modifiedGlobAccKeys = Object.keys(
          modifiedData?.msteams || {}
        );
        const hasMSTeamsChange = msteamsKeys.some((k) =>
          modifiedGlobAccKeys.includes(k)
        );
        if (hasMSTeamsChange && update.msteams) {
          setIsloading(true);
          msteamsKeys.forEach((key) => {
            update.msteams[key] =
              data.msteams?.[key];
          });
        }
      }
      const msteamsKeys = [
        "directory_tenant_id",
        "app_client_id",
        "client_secret_value",
        "client_secret_exp_date",
      ];
      const modifiedGlobAccKeys = Object.keys(
        modifiedData?.msteams || {}
      );
      const hasMSTeamsChange = msteamsKeys.some((k) =>
        modifiedGlobAccKeys.includes(k)
      );
      if (hasMSTeamsChange && update.msteams) {
        setIsloading(true);
        msteamsKeys.forEach((key) => {
          update.msteams[key] =
            data.msteams?.[key]?.trim();
        });
      }
      console.log(
        "update vocemail operator team ::::: " + JSON.stringify(update)
      );
      let saverep = await updateMSTeamsSettings(update);
      console.log("vocemail operator:::::: " + saverep);
      let saverepeMsg = await saverep.json();
      console.log(
        "response vocemail operator::::: " + JSON.stringify(saverepeMsg)
      );

      if (saverepeMsg.status && saverepeMsg.status == "success") {
        setSuccessMessage(saverepeMsg.message);
        setrerender(true);
      } else {
        if (saverepeMsg.message?.errors) {
          saverepeMsg.message.errors.forEach((err) => {
            console.log(
              `err object in  UpdateAccPinCID is :::::: ${JSON.stringify(err)}`
            );
            const paramName = err?.param_name;
            const key = paramName?.substring(paramName.lastIndexOf(".") + 1); // Extract "default_cid"
            setError(paramName, {
              type: "server",
              message: err.message,
            });
            console.log(
              "fjewf " + paramName + " fewfe " + err.message + " fref" + key
            );
            const fieldElement = document.querySelector(
              `input[name="${paramName}"]`
            );
            if (fieldElement) {
              fieldElement.focus();
            }
          });
        }
      }
      setIsloading(false);
    }
  };
  function prepareFinalJson(dirtyFields, data) {
    const modifiedData = {};

    function recurse(dirtyFields, data, modifiedData, path = "") {
      for (const field of Object.keys(dirtyFields)) {
        if (dirtyFields[field] && data.hasOwnProperty(field)) {
          const currentPath = path ? `${path}.${field}` : field;

          if (typeof data[field] === "object" && !Array.isArray(data[field])) {
            modifiedData[field] = {};
            recurse(
              dirtyFields[field],
              data[field],
              modifiedData[field],
              currentPath
            );
          } else if (
            Array.isArray(data[field]) &&
            Array.isArray(dirtyFields[field])
          ) {
            // General handling for other arrays
            modifiedData[field] = data[field].filter(
              (_, index) => dirtyFields[field][index]
            );
          } else {
            modifiedData[field] = data[field];
          }
        }
      }
    }

    recurse(dirtyFields, data, modifiedData);
    return modifiedData;
  }

   function closeSave(e) {
        console.log(`isDirty value is :::::: on close ${isDirty}`);
        reset();
    }
  return (
    <>
      <MDBTabsContent>
        <MDBTabsPane open={basicActive === "tab1"}>
          <MDBRow>
            <MDBCol
              size="2"
              md="2"
              lg="2"
              sm="12"
              className="col-sm-100 pr-0 leftTabs"
            >
              <MDBScrollspy container={containerRef}>
                {/* <MDBScrollspyLink targetRef={section6}>
                    Microsoft Teams
                  </MDBScrollspyLink> */}
              </MDBScrollspy>
            </MDBCol>

            <MDBCol
              size="12"
              md="10"
              sm="12"
              pr-0
              className="col-sm-100 pr-0 leftTabContent"
            >
              <div
                ref={containerRef}
                className="scrollspy-example"
                style={{ maxHeight: "calc(100vh - 27vh) !important" }}
              >
                <section
                  ref={section6}
                  id="section-6"
                  style={{ marginBottom: "15rem" }}
                >
                  <div className="d-flex align-items-center justify-content-between">
                    <div>
                      <div
                        class="general-settings mt-4"
                        style={{ paddingLeft: "10px" }}
                      >
                        Microsoft Teams
                        <a
                          className="text-primary ms-3 text-decoration-underline fw-500"
                          style={{ fontSize: "13px" }}
                          href={`${api_serverUrl}docs/pdfs/Microsoft_Teams_Help_Doc.pdf`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Help
                        </a>
                      </div>
                    </div>
                    {deleteBtn && (
                      <MDBBtn
                        color="danger"
                        className="me-3"
                        onClick={handleDelMsTeamTennantHelper}
                      >
                        <MDBIcon fas icon="trash" className="me-2" />
                        Remove
                      </MDBBtn>
                    )}
                  </div>

                  <div>
                    <div className="add-numbermain">
                      <div className="tel-numbers">Directory (tenant) ID *</div>
                      <div className="w-30">
                        <MDBInput
                          id=""
                          type="text"
                          className="w-100"
                          {...register("msteams.directory_tenant_id")}
                          onChange={(e) => {
                            setValue(
                              `msteams.directory_tenant_id`,
                              e.target.value,
                              { shouldDirty: true }
                            );
                            clearErrors("msteams.directory_tenant_id");
                          }}
                        />
                        {errors?.msteams
                          ?.directory_tenant_id && (
                          <p className="text-danger">
                            {errors?.msteams?.directory_tenant_id.message}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="add-numbermain">
                      <div className="tel-numbers">
                        Application (client) ID *
                      </div>
                      <div className="w-30">
                        <MDBInput
                          id=""
                          type="text"
                          className="w-100"
                          {...register("msteams.app_client_id")}
                          onChange={(e) => {
                            setValue(`msteams.app_client_id`, e.target.value, {
                              shouldDirty: true,
                            });
                            clearErrors("msteams.app_client_id");
                          }}
                        />
                        {errors?.msteams?.app_client_id && (
                          <p className="text-danger">
                            {errors?.msteams?.app_client_id.message}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="add-numbermain">
                      <div className="tel-numbers">Client secret value *</div>
                      <div className="w-30">
                        <MDBInput
                          id=""
                          type="text"
                          className="w-100"
                          {...register("msteams.client_secret_value")}
                          onChange={(e) => {
                            setValue(
                              `msteams.client_secret_value`,
                              e.target.value,
                              { shouldDirty: true }
                            );
                            clearErrors("msteams.client_secret_value");
                          }}
                        />
                        {errors?.msteams
                          ?.client_secret_value && (
                          <p className="text-danger">
                            {errors?.msteams?.client_secret_value.message}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="add-numbermain">
                      <div className="tel-numbers">
                        Client secret expiration date *
                      </div>
                      <div className="w-30">
                        <Controller
                          name="msteams.client_secret_exp_date"
                          control={control}
                          render={({ field, fieldState }) => (
                            <div>
                              <MDBDatepicker
                                inline
                                value={field.value}
                                format="mm/dd/yyyy"
                                disablePast
                                onChange={(value) => {
                                  if (value !== "") {
                                    field.onChange(value);
                                  }
                                }}
                                readonly
                              />
                              {fieldState.error && (
                                <p className="text-danger">
                                  {fieldState.error.message}
                                </p>
                              )}
                            </div>
                          )}
                        />
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </MDBCol>
          </MDBRow>
        </MDBTabsPane>
      </MDBTabsContent>

      {Object.keys(dirtyFields).length !== 0 && (
        <SaveChanges
          onClose={closeSave}
          isdirtyFields={isDirty}
          onSave={(e) => {
            e.preventDefault();
            handleSubmit(onSubmit)();
          }}
        />
      )}
      {successMessage && (
        <>
          <TopSuccess>
            <TopMessage successMessage={successMessage} />
          </TopSuccess>
        </>
      )}

      {delTenantPopUp && (
        <PopupLoader
          title={t("DelMSTeams")}
          content={
            <>
              <div className="d-flex align-items-center bg-danger bg-opacity-25 p-3  rounded-3 square border border-2 border-danger">
                <MDBIcon
                  fas
                  icon="ban"
                  className="me-3"
                  size="lg"
                  color="danger"
                />
                <div>{t("DelMSTeamsWrng")}</div>
              </div>
              <MDBModalFooter className="mt-2 pb-0 px-0">
                <MDBBtn color="secondary" onClick={togglePopUp}>
                  {t("cancel")}
                </MDBBtn>
                <MDBBtn onClick={(e) => handleDelMsTeamTennant(e)}>
                  {t("remove")}
                </MDBBtn>
              </MDBModalFooter>
            </>
          }
          onShow={setDelTenantPopUp}
          onClose={togglePopUp}
        />
      )}
      {isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </>
      )}
      {internalError && (
        <MDBAlert
          open
          className="alert-center"
          color="danger"
          autohide
          position="bottom-right"
          delay={5000}
          onClose={() => setInternalError(false)}
        >
          {errorMessage || "Internal Server Error"}
        </MDBAlert>
      )}
    </>
  );
}

export default MicroSoftTeam;
